import React from 'react';

const SettingsIcon = ({ size = 17,color, filled, className = '' }) => {
  return (
    <>
      {!filled ? (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
            // stroke="#E96618"
            stroke={color?color:'white'}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 12.8794V11.1194C2 10.0794 2.85 9.21945 3.9 9.21945C5.71 9.21945 6.45 7.93945 5.54 6.36945C5.02 5.46945 5.33 4.29945 6.24 3.77945L7.97 2.78945C8.76 2.31945 9.78 2.59945 10.25 3.38945L10.36 3.57945C11.26 5.14945 12.74 5.14945 13.65 3.57945L13.76 3.38945C14.23 2.59945 15.25 2.31945 16.04 2.78945L17.77 3.77945C18.68 4.29945 18.99 5.46945 18.47 6.36945C17.56 7.93945 18.3 9.21945 20.11 9.21945C21.15 9.21945 22.01 10.0694 22.01 11.1194V12.8794C22.01 13.9194 21.16 14.7794 20.11 14.7794C18.3 14.7794 17.56 16.0594 18.47 17.6294C18.99 18.5394 18.68 19.6994 17.77 20.2194L16.04 21.2094C15.25 21.6794 14.23 21.3994 13.76 20.6094L13.65 20.4194C12.75 18.8494 11.27 18.8494 10.36 20.4194L10.25 20.6094C9.78 21.3994 8.76 21.6794 7.97 21.2094L6.24 20.2194C5.33 19.6994 5.02 18.5294 5.54 17.6294C6.45 16.0594 5.71 14.7794 3.9 14.7794C2.85 14.7794 2 13.9194 2 12.8794Z"
            stroke={color?color:'white'}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.1 7.23019C16.29 7.23019 15.55 5.95019 16.45 4.38019C16.97 3.47019 16.66 2.31019 15.75 1.79019L14.02 0.80019C13.23 0.33019 12.21 0.61019 11.74 1.40019L11.63 1.59019C10.73 3.16019 9.25 3.16019 8.34 1.59019L8.23 1.40019C7.78 0.61019 6.76 0.33019 5.97 0.80019L4.24 1.79019C3.33 2.31019 3.02 3.48019 3.54 4.39019C4.45 5.95019 3.71 7.23019 1.9 7.23019C0.86 7.23019 0 8.08019 0 9.13019V10.8902C0 11.9302 0.85 12.7902 1.9 12.7902C3.71 12.7902 4.45 14.0702 3.54 15.6402C3.02 16.5502 3.33 17.7102 4.24 18.2302L5.97 19.2202C6.76 19.6902 7.78 19.4102 8.25 18.6202L8.36 18.4302C9.26 16.8602 10.74 16.8602 11.65 18.4302L11.76 18.6202C12.23 19.4102 13.25 19.6902 14.04 19.2202L15.77 18.2302C16.68 17.7102 16.99 16.5402 16.47 15.6402C15.56 14.0702 16.3 12.7902 18.11 12.7902C19.15 12.7902 20.01 11.9402 20.01 10.8902V9.13019C20 8.09019 19.15 7.23019 18.1 7.23019ZM10 13.2602C8.21 13.2602 6.75 11.8002 6.75 10.0102C6.75 8.22019 8.21 6.76019 10 6.76019C11.79 6.76019 13.25 8.22019 13.25 10.0102C13.25 11.8002 11.79 13.2602 10 13.2602Z"
            fill="#9EA7B626"
          />
        </svg>
      )}
    </>
  );
};

export default SettingsIcon;
